import findPathFromEntityId from "./findPathFromEntityId";

/**
 * Convert graphql menu data to structured navigation data
 *
 * @param {*} allMenuItems: graphql menu data
 * @param {*} sitemap: a sitemap to look for matching slugs
 * @returns
 */

function navDataFormat(allMenuItems, sitemap) {
	function findPath(_n) {
		let path;
		if (_n.url && `${_n.url}`.length > 0 && `${_n.url}` !== "#") {
			path = `${_n.url}`.length > 0 ? _n.url : null;
		}
		if (_n.route && _n.route.parameters && _n.route.parameters.node) {
			let matching_path = findPathFromEntityId(_n.route.parameters.node, sitemap);
			if (matching_path) {
				path = matching_path;
			}
		}
		return path;
	}

	function setBranch(node) {
		let item = {
			title: node.title === "_blank_" ? "" : node.title,
			weight: parseInt(node.weight),
		};
		let path = findPath(node);
		if (path) {
			item.path = path;
		}
		if (node.childrenMenuItems && node.childrenMenuItems.length > 0) {
			item.children = node.childrenMenuItems.map((sub_node) => {
				let sub_item = setBranch(sub_node);
				return sub_item;
			});
		}
		return item;
	}

	if (allMenuItems.edges && allMenuItems.edges.length > 0) {
		return allMenuItems.edges
			.filter(({ node }) => node.parent === null)
			.map(({ node }) => {
				let item = setBranch(node);
				return item;
			});
	} else {
		return [];
	}
}

export default navDataFormat;
